module.exports = __webpack_public_path__ + "static/img/lianmai.1bae3c21.png";